<textarea
  #textarea
  [(ngModel)]="value"
  (input)="onInput($event)"
  [placeholder]="placeholder"
  [rows]="rows"
  class="mention-textarea"
  [class.auto-resize]="autoResize">
</textarea>

<p-overlayPanel #mentionPanel [dismissable]="false" [showCloseIcon]="false" styleClass="mention-dropdown">
  <ng-template pTemplate="content">
    <div class="mention-list" *ngIf="showMentionDropdown && filteredUsers.length > 0">
      <div
        *ngFor="let user of filteredUsers; let i = index"
        class="mention-item"
        [class.selected]="i === selectedIndex"
        (click)="selectUser(user)"
        (mouseenter)="selectedIndex = i">
        <div class="user-avatar-small">
          <img *ngIf="user.profile_pic_url" [src]="user.profile_pic_url" [alt]="user.mentionText" />
          <div *ngIf="!user.profile_pic_url" class="avatar-initials-small">
            {{ getUserInitials(user) }}
          </div>
        </div>
        <div class="user-details">
          <div class="user-name">{{ user.first_name }} {{ user.last_name }}</div>
          <div class="user-role" *ngIf="user.role_name">{{ user.role_name }}</div>
        </div>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
